import { render, staticRenderFns } from "./ResumenFoliosPorBeneficio.vue?vue&type=template&id=76ce4770&scoped=true"
import script from "./ResumenFoliosPorBeneficio.vue?vue&type=script&lang=js"
export * from "./ResumenFoliosPorBeneficio.vue?vue&type=script&lang=js"
import style0 from "./ResumenFoliosPorBeneficio.vue?vue&type=style&index=0&id=76ce4770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce4770",
  null
  
)

export default component.exports